import * as React from 'react';
import ActionPlanEditor from '../../../components/ActionPlanEditor/ActionPlanEditor';
import ApEditorMode from '../../../enums/ApEditorMode';
import {
    ApEditorReducer,
    actionPlanEditorReducer,
} from '../../../sic-lib/reducers/actionPlanEditorReducer';
import { ApPlanBase } from '../../../sic-lib/types/ActionPlan';
import { ApTemplate } from '../../../sic-lib/types/ApTemplate';
import { setTemplate } from '../../../store/communicator';
import { useAppDispatch } from '../../../store/hooks';

interface Props {
    template: ApPlanBase;
}

export default function CommTemplateEditor({ template }: Props) {
    const dispatch = useAppDispatch();

    const [apState, apDispatch] = React.useReducer<ApEditorReducer>(actionPlanEditorReducer, {
        plan: template,
        scopedActions: template.actions,
        location: [],
        editIndex: -1,
    });

    const skipEffect = React.useRef<boolean>(true);

    React.useEffect(() => {
        if (!skipEffect.current) {
            /* 
                A side effect of updating the apEditor state is updating template state in redux 
                to persist the data beyond page changes in the case of interruption i.e.: incoming call
             */
            dispatch(setTemplate(apState.plan));
        } else {
            skipEffect.current = false;
        }
    }, [apState.plan]);

    return (
        <ActionPlanEditor
            apActions={apState.scopedActions}
            apEditMode={ApEditorMode.template}
            apEditIndex={apState.editIndex}
            apLocation={apState.location}
            apRootId={(apState.plan as ApTemplate).templateId}
            apDispatch={apDispatch}
        />
    );
}
